import moment from "moment";

export function defaultCampanhaMetasItem() {
  return {
    id: null,
    nome: "",
    tipoCampanha: "D",
    tipoApuracao: "P",
    metaTotal: 0,
    total: 0,
    image: null,
    dataInicio: moment().format(),
    dataFim: moment().add(1, "days").format(),
    dataApuracao: null,
    status: "Não apurada",
    fechado: false,
    metasOperadores: [],
    mix: [],
    dimensoes: [],
  };
}

export function filtrarValidos(itemArray, referencia, compareFn) {
  const validos = itemArray.filter((item) =>
    referencia.some((ref) => compareFn(item, ref))
  );

  if (validos.length !== itemArray.length) {
    return validos;
  }

  return itemArray;
}

// Ids/codigos vindos do ERP podem ser alfanumericos (ex.: "913-2582"), entao a
// comparacao precisa ser textual -- com coercao numerica o `+valor` viraria NaN
// e nunca casaria.
export function mesmaChaveTextual(a, b) {
  if (a === null || a === undefined || b === null || b === undefined) {
    return false;
  }

  return String(a).trim() === String(b).trim();
}

// Aliases de dominio: preservam a legibilidade nas chamadas sem duplicar a regra.
export const mesmoProdutoId = mesmaChaveTextual;
export const mesmoCodigoOperador = mesmaChaveTextual;

export function resetValidacaoPorTipo(item, validacao) {
  if (item.tipo === "MIX") {
    validacao.reset("item.dimensoes");
  } else {
    validacao.reset("item.mixProdutos");
  }
}

// Re-exporta helpers de campanhas comerciais para acesso centralizado
export {
  computeStatus,
  getStatusConfig,
} from "@/views/Campanhas/components/CampanhasComerciais/helpers/campanhaStatus";
export {
  getValidacaoLabel,
  getTipoLabel,
} from "@/views/Campanhas/components/CampanhasComerciais/helpers/campanhaLabels";
export {
  defaultCampanhaComercial,
  normalizeCampanhaParaApi,
} from "@/views/Campanhas/components/CampanhasComerciais/helpers/campanhaDefaults";